/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalBatchMaintenance extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      recurrence: null,
      start_date: (new Date().toJSON().slice(0, 10).replace(/-/g, '-')),
      start_time: '',
      end_time: '',
      recurrence_param: [],
      errors: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    this.props.updateLoadingModal(false);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    this.setState({
      errors: null,
    });

    this.props.handleSubmit(true);

    const payload = {
      players: [],
    };

    if (this.props.data && this.props.data.length > 0 && this.state.recurrence !== null
      && this.state.recurrence !== undefined) {
      const maintenanceSchedule = {
        start_date: this.state.start_date,
        recurrence: this.state.recurrence,
      };

      if (this.state.recurrence !== 'immediate') {
        maintenanceSchedule.start_time = this.state.start_time;
        maintenanceSchedule.end_time = this.state.end_time;
      }

      if (this.state.recurrence !== 'immediate' && this.state.recurrence === 'weekly') {
        maintenanceSchedule.recurrence_param = this.state.recurrence_param;
      }

      if (this.state.recurrence !== 'immediate' && this.state.recurrence === 'monthly') {
        maintenanceSchedule.recurrence_param = (new Date(this.state.start_date)).getUTCDate();
      }

      payload.players = this.props.data.map((item) => ({
        device_id: item,
        maintenance_schedule: maintenanceSchedule,
      }));

      Helpers.httpRequest(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players`,
        'put',
        JSON.stringify(payload),
        // callback
        () => {
          this.props.handleSubmitSuccess();
          this.props.handleSubmit(false);
        },
        // failback
        (error) => {
          this.setState({
            errors: error,
          }, () => {
            this.props.handleSubmit(false);
          });
        },
      );
    } else {
      this.setState({
        errors: {
          message: 'Please choose a recurrence.',
        },
      }, () => {
        this.props.handleSubmit(false);
      });
    }

    event.preventDefault();
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    if (event.target.name === 'recurrence') {
      if (event.target.value === 'immediate') {
        this.setState({
          start_time: null,
          end_time: null,
        });
      } else if (event.target.value !== 'immediate' && event.target.value !== 'weekly' && event.target.value !== 'monthly') {
        this.setState({
          recurrence_param: [],
        });
      }
    }
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * @param {Event} event
   */
  handleCheckbox(event) {
    this.setState((prevState) => {
      let param = prevState.recurrence_param;

      if (event.target.checked) {
        param.push(event.target.value);
      } else {
        param = [
          ...param.slice(0, param.indexOf(event.target.value)),
          ...param.slice((param.indexOf(event.target.value) + 1)),
        ];
      }

      return {
        recurrence_param: param,
      };
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <form id={this.props.id} onSubmit={this.handleSubmit}>
              <div className="form-group">
                <div className="alert alert-warning">
                  {this.props.data.length}
                  {' '}
                  item
                  {(this.props.data.length !== 1) ? 's' : null}
                  {' '}
                  selected
                </div>
              </div>

              <div className="form-group">
                <div className="form-check">
                  <input disabled={this.props.submitted} checked={this.state.recurrence === 'immediate'} onChange={this.handleChange} className="form-check-input" type="radio" name="recurrence" id="recurrence-immediate" value="immediate" />
                  <label className="form-check-label" htmlFor="recurrence-immediate">
                    Immediate
                  </label>
                </div>

                <div className="form-check">
                  <input disabled={this.props.submitted} checked={this.state.recurrence === 'daily'} onChange={this.handleChange} className="form-check-input" type="radio" name="recurrence" id="recurrence-daily" value="daily" />
                  <label className="form-check-label" htmlFor="recurrence-daily">
                    Daily
                  </label>
                </div>

                <div className="form-check">
                  <input disabled={this.props.submitted} checked={this.state.recurrence === 'weekly'} onChange={this.handleChange} className="form-check-input" type="radio" name="recurrence" id="recurrence-weekly" value="weekly" />
                  <label className="form-check-label" htmlFor="recurrence-weekly">
                    Weekly
                  </label>
                </div>

                <div className="form-check">
                  <input disabled={this.props.submitted} checked={this.state.recurrence === 'monthly'} onChange={this.handleChange} className="form-check-input" type="radio" name="recurrence" id="recurrence-monthly" value="monthly" />
                  <label className="form-check-label" htmlFor="recurrence-monthly">
                    Monthly
                  </label>
                </div>
              </div>

              {(this.state.recurrence && this.state.recurrence !== 'immediate')
                ? (
                  <div>
                    <div className="form-group">
                      <label className="form-check-label" htmlFor="start_date">State Date</label>
                      <input disabled={this.props.submitted} onChange={this.handleChange} className="form-control" type="date" name="start_date" value={this.state.start_date} />
                    </div>
                    <div>
                      <div className="form-group">
                        <label className="form-check-label" htmlFor="start_time">State Time</label>
                        <input disabled={this.props.submitted} onChange={this.handleChange} className="form-control" type="time" name="start_time" value={this.state.start_time} />
                      </div>

                      <div className="form-group">
                        <label className="form-check-label" htmlFor="end_time">End Time</label>
                        <input disabled={this.props.submitted} onChange={this.handleChange} className="form-control" type="time" name="end_time" value={this.state.end_time} />
                      </div>
                    </div>
                  </div>
                )
                : null}

              {(this.state.recurrence && this.state.recurrence === 'weekly')
                ? (
                  <div>
                    <div className="form-check form-check-inline">
                      <input disabled={this.props.submitted} checked={(this.state.recurrence_param.indexOf('sun') > -1)} name="recurrence_param" onChange={this.handleCheckbox} className="form-check-input" type="checkbox" id="sun" value="sun" />
                      <label className="form-check-label" htmlFor="sun">SUN</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input disabled={this.props.submitted} checked={(this.state.recurrence_param.indexOf('mon') > -1)} name="recurrence_param" onChange={this.handleCheckbox} className="form-check-input" type="checkbox" id="mon" value="mon" />
                      <label className="form-check-label" htmlFor="mon">MON</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input disabled={this.props.submitted} checked={(this.state.recurrence_param.indexOf('tue') > -1)} name="recurrence_param" onChange={this.handleCheckbox} className="form-check-input" type="checkbox" id="tue" value="tue" />
                      <label className="form-check-label" htmlFor="tue">TUE</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input disabled={this.props.submitted} checked={(this.state.recurrence_param.indexOf('wed') > -1)} name="recurrence_param" onChange={this.handleCheckbox} className="form-check-input" type="checkbox" id="wed" value="wed" />
                      <label className="form-check-label" htmlFor="wed">WED</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input disabled={this.props.submitted} checked={(this.state.recurrence_param.indexOf('thu') > -1)} name="recurrence_param" onChange={this.handleCheckbox} className="form-check-input" type="checkbox" id="thu" value="thu" />
                      <label className="form-check-label" htmlFor="thu">THU</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input disabled={this.props.submitted} checked={(this.state.recurrence_param.indexOf('fri') > -1)} name="recurrence_param" onChange={this.handleCheckbox} className="form-check-input" type="checkbox" id="fri" value="fri" />
                      <label className="form-check-label" htmlFor="fri">FRI</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input disabled={this.props.submitted} checked={(this.state.recurrence_param.indexOf('sat') > -1)} name="recurrence_param" onChange={this.handleCheckbox} className="form-check-input" type="checkbox" id="sat" value="sat" />
                      <label className="form-check-label" htmlFor="sat">SAT</label>
                    </div>
                  </div>
                )
                : null}

              {(this.state.errors && Object.keys(this.state.errors).length > 0)
                ? (
                  <div className="form-group">
                    <div className="alert alert-danger">
                      <ul>
                        {(Object.keys(this.state.errors).map((item) => (
                          <li key={item}>
                            <strong>{item}</strong>
                            {' '}
                            -
                            {' '}
                            {this.state.errors[item]}
                          </li>
                        )))}
                      </ul>
                    </div>
                  </div>
                )
                : null}

              {(this.props.submitted)
                ? (<Loader />)
                : null}
              <button type="submit" aria-label="submit" style={{ display: 'none' }} disabled={this.props.submitted} />
            </form>
          )
          : null}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalBatchMaintenance.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalBatchMaintenance;
